import { render, staticRenderFns } from "./packageManage.vue?vue&type=template&id=38715ed4&scoped=true&"
import script from "./packageManage.vue?vue&type=script&lang=js&"
export * from "./packageManage.vue?vue&type=script&lang=js&"
import style0 from "./packageManage.vue?vue&type=style&index=0&id=38715ed4&lang=less&scoped=true&"
import style1 from "./packageManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38715ed4",
  null
  
)

export default component.exports